import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";

import "./load-more-button.m.css";

export const LoadMoreButton = ({ onClick }) => {
  const domainSlug = useSelector(state => get(state, ["qt", "domainSlug"], null));
  return (
    <button onClick={onClick} styleName="load-more-button">
      {domainSlug ? "और लोड करें" : "Load More"}
    </button>
  );
};

LoadMoreButton.propTypes = {
  onClick: PropTypes.func
};
